export default "__VITE_ASSET__C5kOpPoq__"